

<div class="app-content content">
  <div class="content-wrapper">
    <!-- <div class="content-header row mb-1">
     
    </div> -->
    <div class="content-body">
      <app-custom-loader-c></app-custom-loader-c>
       
      <section class="card custom_card_pdf">
        <div #invoicetemplate id="invoice-template" class="card-body">
          <!-- Invoice Company Details -->

          <div id="invoice-company-details" class="row">
            <div class="custoemPrintFont col-md-12 col-sm-12 text-center">
            
              <div>
                <!-- <h2 class="stripe-1" >INVOICE</h2> -->
                <a href="http://www.octaitsolution.com/" class="custoemPrintImageWidth"><img class="custoemPrintImageWidth" src="../../../../../assets/custom/images/Octa_Logo1.png" style="width: 19%;float: left;" alt="company logo"
                   /></a>

                <div class="media-body" > 
                  <ul class="ml-2 px-0 list-unstyled">
                    <div style="float: right;  display:inline;">
                      <h2 class="textclass" style="color: #078473;
                      font-weight: bold;">{{model.quotationType}}</h2>
                      <span class="custoemPrintFont textclass" >
                        <span class="textclass" *ngIf="this.model.quotationType=='Quotation'"># Qu_
                          {{("000"+model.quotationNo).slice(-3)}}</span>
                          <span class="textclass" *ngIf="this.model.quotationType=='Proforma_Invoice'"># Pr_
                            {{("000"+model.quotationNo).slice(-3)}}</span></span>
                    
                      <ul class="px-0 list-unstyled">
                      
                      </ul>
                    </div>
    
                    <li style=" font-size: 1.3rem" >
                      Raghuveer Nagar,
                      Anand Corner Apartment,Wadgaon Sheri,
                      Pune, Maharashtra 411014</li>
                      
                      <li style="padding-right: 10rem;">Email: <a style="color: blue;font-size:large; ">info@octaitsolution.com</a> Mobile: +91 8686480808</li>
                    
                      <!-- <li style=" padding-right: 7rem;">Email: <a style="color: blue;font-size:large; ">info@octaitsolution.com</a> Mobile: +91 8686480808</li> -->
                  </ul>
                </div>



               

              </div>



            </div>


         
           
          </div>
          <!--/ Invoice Company Details -->

          <!-- Invoice Customer Details -->
          <div id="invoice-customer-details" class="row pt-2">
            <div class="col-12 text-left">
              <p class="text-muted" style="font-size: x-large !important" >To</p>
            </div>
            <div class="col-6 text-left"  style="font-size:large">
              <ul class="px-0 list-unstyled">
                <li class="text-muted">{{model.customerFullName}}</li>
                <div class="row" >
                  <div class="col-8">
                    <p class="text-muted">
                      {{model.customerAddress}}
                      <br>
                      {{model.customerContact}}
                    </p>
                  </div>
                </div>
                <li class="text-muted" *ngIf="model.customerGSTNO!=''">GST No: {{model.customerGSTNO}}</li>
                <li class="text-muted" *ngIf="model.customerGSTNO==''">GST No: NA</li>

              </ul>
            </div>
            <div class="col-6 text-right" style="margin-top: -2%;">
              <ul class="px-0 list-unstyled" style="font-size: large">
               
                <li><span class="text-muted">Date :</span>{{convertoshort(model.quotationDate)}}</li>
                <!-- <li *ngIf="model.balanceAmount!=0"><span class="text-muted">Terms :</span> Due on Receipt</li> -->
                <!-- <li *ngIf="model.balanceAmount!=0"><span class="text-muted">Due Date :</span> {{duedate(model.billDate)}}</li> -->
              </ul>

            </div>
          </div>

          
          <!--/ Invoice Company Details -->

          <!-- Invoice Customer Details -->
         
          <!--/ Invoice Customer Details -->

          <!-- Invoice Items Details -->
          <div id="invoice-items-details" class="pt-2">
            <div class="row textclass">
              <div class="customePrint table-responsive col-sm-12 textclass">
                <table class="table textclass">
                  <thead>
                    <tr>
                      <th  style="width: 3%;padding:0.75rem 0.4rem;">#</th>
                      <th style="width: 48%">Item</th>
                      <th class="tdclass" style="text-align: right;">Rate </th>
                      <th *ngIf="this.model.quotationGSTIsExcluded=='false'" style="text-align: right;">GST</th>
                      <th  style="text-align: center;">Quantity</th>
                      <th class=" text-md-right">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                   
                    <tr *ngFor="let obj of lstQuotationItems; let i=index">
                      <th  scope="row" style="width: 3%;padding:0.75rem 0.4rem;">{{i+1}}</th>
                      <td>
                        <p>{{obj.quotationItem}}</p>
                        </td>
                      <td  class="ratequotation" >
                      <p>{{obj.quotationItemRate}}</p>
                      </td>
                      <td  *ngIf="this.model.quotationGSTIsExcluded=='false'" class="gstquotation" > {{obj.quotationItemGST}}</td>
                      <td class="quotationItemQuantity"> {{obj.quotationItemQuantity}}</td>
                      <td class=" text-md-right"> {{obj.quotationAmmount }}</td>

                    
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-7 text-left">
               
              </div>
              <div class="col-5">
               
                <div class="customePrint table-responsive textclass">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td class="textclass">Total</td>
                        <td class=" text-right textclass">{{model.totalAmount}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
               
              </div>
            </div>
          </div>

          <!-- Invoice Footer -->
          <div id="invoice-footer textclass">
            <div class="row">
              <div class="col-7 ">
                <h6 class="textclass"> Terms & Conditions</h6>
                <h6 *ngFor="let obj of termCondition;" class="textclass">
                  {{obj}}
                </h6>
               
                <p class="textclass">Enquiry Contact Number: {{model.quotationEnquiryContact}}</p>
              </div>
            
            </div>
            <div class="text-center">
              <h6> This is an electronically generated {{model.quotationType}}, no sign required.</h6>
             </div>
            
          </div>
      
          <!--/ Invoice Footer -->

        </div>
        <div class="row">
          <div class="col-7 text-center">
          </div>
          <div class="col-5 text-center">
            <button type="button" class="btn btn-info btn-lg my-1" (click)="getPrint1('invoice-template')"><i class="la la-paper-plane-o"></i> Print
              </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>